import { useT } from "../../../../i18n";
import { latestGenW } from "../../../../utils/energyDevices";
import { KpiTile, formatWatt } from "./EnergyKpi";
import "./EnergyInsight.css";

// 스마트폴의 지금 값. 합계(큰 숫자) 아래 태양광 · 풍력 · 소비 · 배터리 타일 2×2.
// 큐브 카드(DeviceEnergyCard)와 같은 타일을 써서 폴 · 큐브 화면이 같은 모양이 된다.
// 전에는 태양광/풍력 비율 막대였는데, 비율만 보이고 크기는 안 보였고 소비 · 배터리는 각주로 밀려 있었다.
// 색은 폴 타임라인 차트와 같다 — 태양광 초록, 풍력 파랑, 소비 주황.

export default function PowerGeneration({ latest, statusMessage }) {
  const t = useT();

  if (statusMessage) {
    return (
      <div className="panel ei-panel">
        <span className="panel-title">{t("energy.generation.title")}</span>
        <div className="ei-empty-message">{statusMessage}</div>
      </div>
    );
  }

  return (
    <div className="panel ei-panel">
      <span className="panel-title">{t("energy.generation.title")}</span>

      <div className="ei-now-total">
        {formatWatt(latestGenW(latest, "POLE"))}
        <span className="ei-now-unit">W</span>
      </div>

      <div className="ei-kpis ei-kpis--2">
        <KpiTile label={t("energy.generation.solar")} value={latest?.currentSolarW} unit="W" color="#4ad4a8" />
        <KpiTile label={t("energy.generation.wind")} value={latest?.currentWindW} unit="W" color="#78aee8" />
        <KpiTile label={t("energy.generation.cons")} value={latest?.currentConsumptionW} unit="W" color="#FFA500" />
        <KpiTile label={t("energy.generation.battery")} value={latest?.currentStoragePercent} unit="%" color="#4aa8d8" />
      </div>
    </div>
  );
}
